<template>
  <table class="table table-hover table-sm" style="width:100%;" id="dt-table">
    <thead class="bg-info">
      <tr>
        <th v-for="column in parameters.columns" v-html="title(column)"></th>
      </tr>
    </thead>
  </table>
</template>

<script>
import 'admin-lte/plugins/datatables/jquery.dataTables.min.js'
import 'admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js'

export default {
  props: {
    searching: { type: Boolean, default: true },
    columns: { type: Array },
    order: { type: Array, default: [1, "asc"] },
    columnDefs: { type: Array, default: [] },
    ajax: { type: Object, default: {} },
    options: {},
  },
  data() {
    return {
      dataTable: {},
    }
  },
  methods: {
    title(column) {
      return column.title;
    },
  },
  computed: {
    parameters() {
      const vm = this;
      return window.$.extend({
        serverSide: true,
        processing: true,
        searching: this.searching,
        order: this.order,
      }, {
        ajax: this.ajax,
        columns: this.columns,
        columnDefs: this.columnDefs,
        createdRow(...args) {
          vm.$emit('created-row', ...args);
        },
        drawCallback(...args) {
          vm.$emit('draw', ...args);
        },
        footerCallback(...args) {
          vm.$emit('footer', ...args);
        },
        // formatNumber(...args) {
        //   vm.$emit('format', ...args);
        // },
        headerCallback(...args) {
          vm.$emit('header', ...args);
        },
        infoCallback(...args) {
          vm.$emit('info', ...args);
        },
        initComplete(...args) {
          vm.$emit('init', ...args);
        },
        preDrawCallback(...args) {
          vm.$emit('pre-draw', ...args);
        },
        rowCallback(...args) {
          vm.$emit('draw-row', ...args);
        },
        stateLoadCallback(...args) {
          vm.$emit('state-load', ...args);
        },
        stateLoaded(...args) {
          vm.$emit('state-loaded', ...args);
        },
        stateLoadParams(...args) {
          vm.$emit('state-load-params', ...args);
        },
        stateSaveCallback(...args) {
          vm.$emit('state-save', ...args);
        },
        stateSaveParams(...args) {
          vm.$emit('state-save-params', ...args);
        },
      }, this.options);
    }
  },
  mounted() {
    this.dataTable = window.$(this.$el).DataTable(this.parameters);
  },
  destroyed() {
    this.dataTable.destroy();
  }
}
</script>

<style>
@import 'admin-lte/plugins/datatables-bs4/css/dataTables.bootstrap4.min.css';
</style>